import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  Text,
  Flex,
  Box,
  Avatar,
  Button,
  ModalHeader,
  ModalFooter,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { useGetContactByIdQuery } from '@/store/query/contacts';
import ContentLoader from 'react-content-loader';
import { KText } from '@/ui-library/components/text';

const Loader = ({ props }) => {
  return (
    <ContentLoader
      width={200}
      height={40}
      viewBox="0 0 200 40"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <circle cx="30" cy="16" r="17" />
      <rect x="55" y="0" rx="4" ry="4" width="200" height="10" />
      <rect x="55" y="20" rx="4" ry="4" width="100" height="10" />
    </ContentLoader>
  );
};

const Contact = ({ id, reason = 'Update Failed' }) => {
  const { data: contact, isFetching } = useGetContactByIdQuery({
    contactId: id,
  });
  if (isFetching)
    return (
      <Box>
        <Loader />
      </Box>
    );
  return (
    <Flex mb="12px">
      <Box>
        <Avatar
          width="36px"
          height="36px"
          src={contact?.image_url}
          name={contact?.first_name}
        />
      </Box>
      <Box flex="1" ml="12px">
        <KText color="secondary-900" size="sm-semi-bold">
          {contact?.first_name} {contact?.last_name}
        </KText>
        <KText color="secondary-700" variant="muted">
          {contact?.email}
        </KText>
      </Box>
      <Box width="150px">
        <KText color="pastel-1-dark">{reason}</KText>
      </Box>
    </Flex>
  );
};

export const BulkError = ({
  contacts,
  title = 'Update Failed',
  clearSelected = () => {},
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (contacts?.length === 0) return;
    onOpen();
  }, [contacts, onOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        clearSelected();
        onClose();
      }}
      size="md"
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton
          onClose={() => {
            clearSelected();
            onClose();
          }}
        />
        <ModalHeader>
          <Text as="h1" size="lg-semi-bold">
            {title}
          </Text>
        </ModalHeader>
        <ModalBody>
          <Box>
            {contacts?.map((contact) => (
              <Contact
                id={contact?.id}
                key={contact?.id}
                reason={contact?.message}
              />
            ))}
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            width="full"
            onClick={() => {
              clearSelected();
              onClose();
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const BulkActionError = ({ contactsIds, reason }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (contactsIds?.length === 0) return;
    onOpen();
  }, [contactsIds, onOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton onClose={onClose} color="secondary-700" />
        <ModalHeader>
          <KText color="secondary-900" as="h1" size="lg-semi-bold">
            Update Failed
          </KText>
          <KText variant="muted" color="secondary-700">
            Candidate already active in different sequence and can't be added to
            this Flow as it violates exclusivity.
          </KText>
        </ModalHeader>
        <ModalBody>
          <Box>
            {contactsIds?.map((id) => (
              <Contact id={id} key={id} reason={reason} />
            ))}
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button width="full" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
